import authAxios from "../common/authAxios";

class PersonalPageService {

    async uploadPhoto(photoFile) {
        const formData = new FormData();
        formData.append("documentFile", photoFile);
        return await authAxios.post(`/file/upload-document?type=image_3x4`,formData, {
            /*headers: {
                'Content-Type': 'multipart/form-data'
            }*/
        })
    }

    async personalInformation(data) {
        return await authAxios.post("/personal-info/save-profile-info", data)
    }
    async getPersonalInformation() {
        return await authAxios.get("/personal-info/")
    }
    async getSocialStatusTypes(){
        return await authAxios.get("/dictionaries/social-status-type")
    }
    async getPersonalInformationByIds(ids){
        return await authAxios.get(`/personal-info/get-by-ids?userIds=${ids}`)
    }   
    
}

export default PersonalPageService;